/**
 * Purpose: Informational panel showing a summary of the selected game mode.
 * Owns: Mode name display, summary bullet points.
 * Notes: Displayed on each mode's setup page so players understand the rules
 *        before starting. Informational only — no interactive controls.
 *        Uses theme tokens exclusively (CS-22).
 */

interface ModeSummaryProps {
  /** Display name of the mode (e.g., "Race") */
  modeLabel: string;
  /** Bullet-point summary of how this mode works */
  summaryPoints: string[];
}

export function ModeSummary({ modeLabel, summaryPoints }: ModeSummaryProps) {
  return (
    <div style={styles.container}>
      <h3 style={styles.heading}>{modeLabel} Mode</h3>
      <ul style={styles.list}>
        {summaryPoints.map((point, index) => (
          <li key={index} style={styles.item}>
            {point}
          </li>
        ))}
      </ul>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    padding: '1rem',
    borderRadius: '10px',
    backgroundColor: 'var(--bg-surface)',
    border: '1px solid rgba(212, 168, 67, 0.2)',
  },
  heading: {
    fontSize: '1rem',
    fontWeight: '700',
    color: 'var(--accent-gold)',
    marginBottom: '0.5rem',
    fontFamily: 'var(--font-family-display)',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
  },
  item: {
    fontSize: '0.85rem',
    color: 'var(--text-light)',
    paddingLeft: '1rem',
    position: 'relative' as const,
  },
};
